var _excluded = ["steps", "currentStepIndex", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { TrackerStep } from './TrackerStep/TrackerStep';
import { jsx as _jsx } from "react/jsx-runtime";
export var Tracker = forwardRef((_ref, ref) => {
  var _steps$currentStepInd;

  var {
    steps,
    currentStepIndex,
    variant = 'horizontal'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useStyleConfig('Tracker', {
    variant
  });

  var getStepStatus = index => {
    if (currentStepIndex >= steps.length - 1) {
      return 'complete';
    }

    if (index < currentStepIndex) {
      return 'done';
    }

    if (currentStepIndex === index) {
      return 'active';
    }

    return 'incomplete';
  };

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "Tracker",
    ref: ref,
    __css: styles
  }, props), {}, {
    role: "progressbar",
    "aria-valuenow": currentStepIndex,
    "aria-valuetext": (_steps$currentStepInd = steps[currentStepIndex]) === null || _steps$currentStepInd === void 0 ? void 0 : _steps$currentStepInd.label.text,
    "aria-valuemin": 0,
    "aria-valuemax": steps.length,
    "aria-label": "linearprogress",
    children: steps.map((step, index) => /*#__PURE__*/_jsx(TrackerStep, {
      index: index,
      label: step.label,
      "data-testid": "tracker-step-".concat(index),
      description: step.description,
      invalid: step.invalid,
      status: getStepStatus(index),
      stepsAmount: steps.length,
      variant: variant
    }, "tracker-step-".concat(step.label.text, "-").concat(index)))
  }));
});
Tracker.displayName = 'Tracker';
//# sourceMappingURL=Tracker.js.map